/**
 * Default Design → "Please design it for me" once per full page load.
 * Syncs price + variant id via the same section fetch Dawn uses (no pill reorder).
 */
(function () {
  var done = false;
  var tries = 0;
  var MAX_TRIES = 30;

  function textHasPlease(text) {
    return String(text || '')
      .toLowerCase()
      .indexOf('please design') !== -1;
  }

  function isPleaseVariant(variant) {
    if (!variant) return false;
    if (textHasPlease(variant.name) || textHasPlease(variant.title) || textHasPlease(variant.public_title)) {
      return true;
    }
    var opts = variant.options || [];
    for (var i = 0; i < opts.length; i++) {
      if (textHasPlease(opts[i])) return true;
    }
    return false;
  }

  function findDesignPleaseRadio(root) {
    var scope = root || document;
    var fieldsets = scope.querySelectorAll('.product-form__input');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend, .form__label');
      var title = legend ? legend.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      if (title.indexOf('design') === -1) continue;

      var radios = fieldsets[i].querySelectorAll('input[type="radio"]');
      for (var r = 0; r < radios.length; r++) {
        if (textHasPlease(radios[r].value)) return radios[r];
      }

      var select = fieldsets[i].querySelector('select');
      if (select) {
        for (var o = 0; o < select.options.length; o++) {
          if (textHasPlease(select.options[o].value)) {
            return { select: select, index: o, option: select.options[o] };
          }
        }
      }
    }
    return null;
  }

  function readSelectedVariant(vs) {
    var el = vs && vs.querySelector('[data-selected-variant]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || 'null');
    } catch (e) {
      return null;
    }
  }

  function selectedOptionValueIds(vs) {
    return Array.prototype.slice
      .call(vs.querySelectorAll('fieldset input:checked, select option[selected]'))
      .map(function (el) {
        return el.dataset.optionValueId;
      })
      .filter(Boolean);
  }

  function selectPleaseInDom(please) {
    if (please.tagName === 'INPUT') {
      please.checked = true;
      return please;
    }
    if (please.select && please.option) {
      Array.prototype.forEach.call(please.select.options, function (opt) {
        opt.removeAttribute('selected');
      });
      please.select.selectedIndex = please.index;
      please.option.setAttribute('selected', 'selected');
      return please.option;
    }
    return null;
  }

  function applySectionUpdate(productInfo, html) {
    var productUrl = productInfo.dataset.url || window.location.pathname;
    if (typeof productInfo.handleUpdateProductInfo === 'function') {
      productInfo.handleUpdateProductInfo(productUrl)(html);
      return;
    }

    // Fallback if class API is unavailable
    var variant = null;
    try {
      var raw = html.querySelector('variant-selects [data-selected-variant]');
      variant = raw ? JSON.parse(raw.textContent || 'null') : null;
    } catch (e) {
      variant = null;
    }
    if (!variant || !variant.id) return;

    productInfo.querySelectorAll('form [name="id"]').forEach(function (input) {
      input.value = String(variant.id);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    var sectionId = productInfo.dataset.section;
    var priceSrc = html.getElementById('price-' + sectionId);
    var priceDest = productInfo.querySelector('#price-' + sectionId);
    if (priceSrc && priceDest) priceDest.innerHTML = priceSrc.innerHTML;

    var vsDest = productInfo.querySelector('variant-selects');
    var vsSrc = html.querySelector('variant-selects');
    if (vsDest && vsSrc) vsDest.innerHTML = vsSrc.innerHTML;

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.variantChange, {
        data: { sectionId: sectionId, html: html, variant: variant },
      });
    }
  }

  function apply() {
    if (done) return;
    tries += 1;

    var productInfo = document.querySelector('product-info');
    var vs = productInfo && productInfo.querySelector('variant-selects, variant-radios');
    if (!productInfo || !vs) {
      if (tries < MAX_TRIES) setTimeout(apply, 100);
      return;
    }

    var please = findDesignPleaseRadio(vs);
    if (!please) {
      // No Design option on this product
      done = true;
      return;
    }

    var current = readSelectedVariant(vs);
    if (isPleaseVariant(current)) {
      // Ensure the Please radio/select matches server state
      selectPleaseInDom(please);
      done = true;
      return;
    }

    var targetInput = selectPleaseInDom(please);
    var optionValues = selectedOptionValueIds(vs);
    if (!optionValues.length) {
      if (tries < MAX_TRIES) setTimeout(apply, 100);
      return;
    }

    done = true;

    var sectionId = productInfo.dataset.section;
    var productUrl = productInfo.dataset.url || window.location.pathname;
    var requestUrl =
      productUrl +
      (productUrl.indexOf('?') === -1 ? '?' : '&') +
      'section_id=' +
      encodeURIComponent(sectionId) +
      '&option_values=' +
      optionValues.join(',');

    fetch(requestUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        applySectionUpdate(productInfo, html);

        // Keep focus/selection UX stable
        if (targetInput && targetInput.id) {
          var again = document.getElementById(targetInput.id);
          if (again && again.focus) again.blur();
        }
      })
      .catch(function (err) {
        console.error('[uc-design-default]', err);
        // Allow one more attempt if fetch failed
        done = false;
        if (tries < MAX_TRIES) setTimeout(apply, 250);
      });
  }

  function start() {
    var run = function () {
      var ready = typeof customElements !== 'undefined' && customElements.whenDefined
        ? customElements.whenDefined('product-info')
        : Promise.resolve();

      ready
        .then(function () {
          setTimeout(apply, 80);
        })
        .catch(function () {
          setTimeout(apply, 150);
        });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  }

  start();
})();
